import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://events.imu7.com";
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function saveTokens(data) {
  try {
    if (data?.access_token) localStorage.setItem("access_token", data.access_token);
    if (data?.refresh_token) localStorage.setItem("refresh_token", data.refresh_token);
  } catch {}
}

export function clearTokens() {
  try {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
  } catch {}
}

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("access_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

let refreshPromise = null;
api.interceptors.response.use(null, async (error) => {
  const orig = error.config || {};
  const url = orig.url || "";
  const rt = localStorage.getItem("refresh_token");
  const skip = url.includes("/auth/login") || url.includes("/auth/refresh") || url.includes("/auth/register");
  if (error.response?.status === 401 && rt && !orig._retried && !skip) {
    orig._retried = true;
    try {
      refreshPromise =
        refreshPromise ||
        axios.post(`${API}/auth/refresh`, { refresh_token: rt }, { withCredentials: true });
      const { data } = await refreshPromise;
      refreshPromise = null;
      saveTokens(data);
      return api(orig);
    } catch {
      refreshPromise = null;
      clearTokens();
    }
  }
  return Promise.reject(error);
});

// simple response error normalizer
export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
